<template>
    <span>(*)</span>
    <!-- <span class="text-red-500">(*)</span> -->
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'RequiredMark',
});
</script>
